export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00333.e57f9118.png";